<template>
  <div>


    <div class="mt-4">
      <h2>Wählen Sie die Anzeigengröße aus</h2>

      <div v-if="false && preview_campain_id" class="absolute right-0 mt-1 mr-10 p-5 border-8 w-1/3 invisible sm:visible">
        <div class="text bg-white min-h-20">
          {{ preview_campain.description }}<br>
          <ul class="mt-1">
            <li v-for="(text, idx) in preview_campain.points" :key="idx">{{ text.text }}</li>
          </ul>
        </div>
      </div>

      <div class="mt-2 grid grid-cols-2 sm:grid-cols-3 gap-2">
        <div
          v-for="campain in campains"
          @click="$emit('select', campain.id)"
          @mouseover="preview_campain_id = campain.id"
          @mouseout="preview_campain_id = null"
          :key="campain.id"
          class="campain overflow-auto relative p-4 border-8 border-gray-200 hover:border-gray-500 cursor-pointer transition-all duration-200 flex flex-col justify-between"
          :class="{
            'border-gray-700': selected_campain == campain.id
          }"
        >
          <img
            :src="base_url_assets + require(`../assets/images/${campain.preview}`)" alt="Teaser Image - Inserate Arbogast"
            class="campain-preview transition-all ease-out duration-75"
          >

          <div class="text bg-white text-base">
            <!-- {{ campain.description }}<br> -->
            <ul class="mt-1">
              <li v-for="(text, idx) in campain.points" :key="idx" v-html="text.text"></li>
            </ul>
          </div>

          <div class="text-center pb-3">
            <span>{{ campain.title }} {{ campain.price }} €</span><br>
            <span class="text-base">{{ campain.subtitle }}</span>
          </div>
        </div>
      </div>

      <div v-if="selected_campain || preview_campain_id" class="mt-4">
        <h2>Ausgewählte Leistung</h2>

        <div class="mt-1 text bg-white min-h-20">
          {{ preview_campain.description }}<br>
          <ul class="mt-1">
            <li v-for="(text, idx) in preview_campain.points" :key="idx" v-html="text.text"></li>
          </ul>
        </div>
      </div>

      <p class="mt-2">
        Alle Preise netto zzgl. 5&nbsp;% Werbeabgabe und 20&nbsp;% MwSt. Bei Online-Formaten fällt
        keine Werbeabgabe an. Rabatte auf Anfrage (z.B. für Jugend-Veranstaltungen).
        Das Redaktionsteam behält sich vor, Inhalte, die dem Leitbild und Zielbild
        widersprechen, abzulehnen.
      </p>

      <p class="mt-2">
        Preise für Veranstaltungen der Diözese Feldkirch: Kleine Bild- oder Textbox:
        €&nbsp;75; Mittlere Bild- und Textbox: €&nbsp;150; Große Bild- und Textbox:
        €&nbsp;225; Sonderform online: €&nbsp;120. Unserem Träger, der Katholischen
        Kirche Vorarlberg, sind ermäßigte Preise für Einrichtungen der Diözese ein
        Anliegen. Deshalb können wir den angeführten Rabatt gewähren.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campains: {
      type: Array,
      required: true
    },
    selected_campain: {
      type: [Number, String],
      required: true
    },
    base_url_assets: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      preview_campain_id: null,
    }
  },
  methods: {},
  computed: {
    preview_campain() {
      if( !this.preview_campain_id && !this.selected_campain ) return
      if( this.preview_campain_id ) {
        return this.campains.find((c) => c.id == this.preview_campain_id)
      }
      if( this.selected_campain ) {
        return this.campains.find((c) => c.id == this.selected_campain)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.campain {
  min-height: 300px;
  height: fit-content;
}
.campain .text {
  position: absolute;
  visibility: hidden;
}
.campain:hover img {
  position: absolute;
  visibility: hidden;
}
.campain:hover .text {
  visibility: visible;
}
</style>
